import React from 'react'
import PicklistField from 'core/components/validatedForm/DropdownField'
import ClusterDomainPicklist from '../ClusterDomainPicklist'

const ClusterDomainField = ({ values, value, onChange, required = true, disabled = false }) => (
  <PicklistField
    DropdownComponent={ClusterDomainPicklist}
    id="domainId"
    label="Domain"
    value={value}
    onChange={onChange}
    cloudProviderId={values.cloudProviderId}
    cloudProviderRegionId={values.cloudProviderRegionId}
    tooltip="Select the base domain name to be used for the API and service FQDNs"
    required={required}
    disabled={disabled}
  />
)

export default ClusterDomainField
